export default __webpack_public_path__ + "static/media/fan.35eb2216.svg";